import React from 'react';
import { ReactSVG } from 'react-svg';

import { TextField } from '../TextField';
import { isWebUrlValid } from './webUtils';
import { classNames } from 'helpers';

const WebTextField = ({
  value,
  onChange,
  error,
  disabled,
  cssClassName,
  ...props
}: any) => {
  const url = typeof value === 'string' ? value : '';

  const isValid = !url || isWebUrlValid(url);
  const showIcon = disabled && url && isValid;

  // If URL is valid, don't show external error (it will clear on next form validation)
  const displayError = (url && isValid) ? undefined : (!isValid ? 'Neispravna web adresa' : error);

  const handleIconClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (url && isValid) {
      // Add protocol if missing
      const urlWithProtocol = /^https?:\/\//i.test(url) ? url : `https://${url}`;
      window.open(urlWithProtocol, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div className="relative">
      <TextField
        {...props}
        value={url}
        onChange={onChange}
        error={displayError}
        placeholder="npr. www.example.com"
        inputMode="url"
        type="url"
        disabled={disabled}
        cssClassName={classNames(cssClassName, showIcon ? "pr-8" : "")}
      />
      {showIcon && (
        <button
          type="button"
          onClick={handleIconClick}
          className="absolute right-2 top-[54px] -translate-y-1/2 z-20 p-1 rounded hover:bg-blue-600 transition-colors duration-200 group"
          title={`Otvori ${url}`}
        >
          <ReactSVG
            src="/media/icons/external-link.svg"
            className="w-5 h-5 text-blue-500 group-hover:text-white transition-colors duration-200"
          />
        </button>
      )}
    </div>
  );
};

export default React.memo(WebTextField);
